<div id="signin" class="w-full max-w-lg mx-auto px-4 py-6">
  <!-- Messages -->
  <div class="form-message" *ngIf="errorMessage">
    <div class="form-message-error">
      {{ errorMessage }}
    </div>
  </div>
  <div class="form-message" *ngIf="showForgotPasswordSuccess">
    <div class="form-message-success">
      Password changed successfully, try signing in again.
    </div>
  </div>

  <!-- Loading -->
  <div class="flex justify-center py-12" *ngIf="currentState === 'SigningIn' || currentState === 'ForgotPasswordSubmitting' || currentState === 'NewPasswordRequiredSubmitting'">
    <div class="w-12 h-12 rounded-full border-2 border-white/20 border-t-indigo-400 animate-spin" role="status" aria-label="Loading"></div>
  </div>

  <!-- Sign In Form -->
  <div *ngIf="currentState === 'SignedOut' || currentState === 'SignInFailed' || currentState === 'ForgotPasswordFailed'">
    <div class="form-container overflow-hidden">
      <div class="form-header">
        <h2 class="form-title">Sign in to your account</h2>
      </div>
      <form class="form-body space-y-4 mt-4" [formGroup]="userForm" (ngSubmit)="signin()">
        <div class="form-field">
          <label for="email" class="form-label">Email or Username</label>
          <div class="form-field-input-wrapper">
            <p class="form-error mb-1" *ngIf="userForm.get('email')?.touched && userForm.get('email')?.errors?.['required']">
              Email or username is required.
            </p>
            <input id="email" type="text" formControlName="email" autocomplete="username" class="form-input">
          </div>
        </div>
        <div class="form-field">
          <div class="flex items-center justify-between">
            <label for="password" class="form-label">Password</label>
            <div class="text-sm">
              <a class="font-semibold text-indigo-400 hover:text-indigo-300 cursor-pointer" (click)="forgotUserPassword()">Forgot password?</a>
            </div>
          </div>
          <div class="form-field-input-wrapper relative">
            <input
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              class="form-input pr-10">
            <button
              type="button"
              class="absolute inset-y-0 right-0 flex items-center px-3 text-slate-300 hover:text-slate-100 focus:outline-none password-toggle-btn"
              (click)="showPassword = !showPassword"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
              <i
                class="fa-solid fa-fw text-sm"
                [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'">
              </i>
            </button>
          </div>
        </div>
        <div class="pt-2">
          <button type="submit" class="form-button form-button-primary w-full" [disabled]="!userForm.valid">Sign in</button>
        </div>
        <div class="pt-2 space-y-4">
          <div class="relative py-2">
            <span class="absolute inset-0 flex items-center justify-center">
              <span class="bg-[#2a3a6c] px-3 text-xs font-medium text-slate-300">or continue with</span>
            </span>
            <div class="border-t border-white/10"></div>
          </div>
          <p *ngIf="sessionParam" class="text-xs text-amber-300/90 text-center mb-2">
            Please use the email address you used for payment.
          </p>
          <div id="google-signin-button" class="flex justify-center min-h-[40px]"></div>
          <p class="text-center pt-2 text-sm">
            <span class="text-slate-400">Don't have an account?</span>
            <a class="ml-1.5 font-semibold text-indigo-400 hover:text-indigo-300 cursor-pointer" (click)="triggerSignup.emit()">Sign up</a>
          </p>
        </div>
      </form>
    </div>
  </div>

  <!-- Forgot Password -->
  <div id="forgotPassword" *ngIf="currentState === 'ForgotPassword'">
    <app-forgot-password></app-forgot-password>
  </div>

  <!-- New Password Required -->
  <div id="newPasswordRequired" *ngIf="currentState === 'NewPasswordRequired'">
    <app-new-password-required></app-new-password-required>
  </div>
</div>
